import { ReportColumn } from 'types';
import { useReportColumns } from '../../../../hooks';

export const useLateResponseColumns = (): ReportColumn[] => {
  const {
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    dateConsultationRespondedTo,
    lateResponseReason,
    otherReason,
    responseType,
  } = useReportColumns();

  return [
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    dateConsultationRespondedTo,
    lateResponseReason,
    otherReason,
    responseType,
  ];
};
